import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import Pagination from '../../model/pagination';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import QueryEncoder from '../queryEncoder';
import EmailAccountModel from '../../model/emailAccount.model';
import {catchError, switchMap} from 'rxjs/operators';

@Injectable()
export default class EmailAccountService {
  public constructor(private http: HttpClient) {
  }

  public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string, additionalInfo?: any): Observable<Pagination<EmailAccountModel>> {
    query = query || '';
    page = page || 1;
    limit = limit || 100;
    sort = sort || '';

    let sorting = {};
    sorting[sort] = direction;

    let q = {query, page, limit, sorting};

    if (additionalInfo) {
      Object.assign(q, additionalInfo);
    }
    return this.http
      .get<Pagination<EmailAccountModel>>(environment.apiUrl + '/email-accounts?' + QueryEncoder.encodeURI(q));
  }

  public update(account: EmailAccountModel): Observable<boolean> {
    return this.http.put<boolean>(environment.apiUrl + '/email-accounts/' + account.id, account).pipe(switchMap(r => of(true)), catchError(e => of(false)));
  }

  public create(account: EmailAccountModel): Observable<EmailAccountModel> {
    return this.http.post<EmailAccountModel>(environment.apiUrl + '/email-accounts', account);
  }

  public delete(account: EmailAccountModel): Observable<boolean> {
    return this.http.delete(environment.apiUrl + '/email-accounts/' + account.id).pipe(switchMap(r => of(true)), catchError(e => of(false)));
  }
}
